import React from "react";
import PaginatedTable from "./paginatedTable";
import { Theme } from "../theme/colors";

interface SQLTableLoaderProps {
  theme: Theme;
  isLoading: boolean;
  error: string | null;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  tableData: any[];
}

const SQLTableLoader: React.FC<SQLTableLoaderProps> = ({ theme, isLoading, error, tableData }) => {
  if (isLoading) {
    return <div>Thinking</div>;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  return (
    <>
      <PaginatedTable theme={theme} data={tableData} />
      {/* <DateColumnSelector data={tableData} /> */}
    </>
  );
};

export default SQLTableLoader;
